import Vue from 'vue'
import vueCustomElement from 'vue-custom-element'
import Swiper from 'vue-awesome-swiper'
import App from './App.vue'
import DataLayer from './plugins/DataLayer'

Vue.use(vueCustomElement)
Vue.use(Swiper)
Vue.use(DataLayer, { debug: process.env.NODE_ENV !== 'production' })

Vue.customElement('pce-featuredproducts', App)
